import { ColorPicker } from "antd";

interface FontColorFieldProps {
  title?: string;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

export default function FontColorField({ title = "", value = "rgb(0,0,0)", onChange, disabled }: FontColorFieldProps) {
  const handleChange = (color: string) => {
    if (onChange) {
      onChange(color);
    }
  };

  const hasTitle = title && title.trim() !== "";

  return (
    <div className={hasTitle ? "flex" : ""}>
      {hasTitle && <label className={"text-left mb-2 w-[35%]"}>{title}</label>}
      <div className={`flex flex-col ${hasTitle ? "w-[65%]" : "w-full"}`}>
        <ColorPicker
          defaultFormat="rgb"
          disabled={disabled}
          defaultValue={value}
          onChange={(color) => handleChange(color.toRgbString())}
          value={value}
          showText
          style={{
            cursor: "pointer",
            width: hasTitle ? "35%" : "100%",
          }}
        />
      </div>
    </div>
  );
}
